module.exports = __webpack_public_path__ + "assets/9ec0a2638b42523bef52559d622b14d6.svg";